import React from "react";
import {connect} from "react-redux";

const UserWelcomeComponentDashboard = (props) => {
    return(
        <div className="userWelcome">
            <h1 className="userWelcomeTypingTitle">Hello {props.name},</h1>
            <h2 className="userWelcomeTypingSubTitle">Your book room is empty. </h2>
            <h3 className="userWelcomeTypingSubTitleSubTitle">Please click the plus button to add a book.</h3>
        </div>
    );
};

function mapStateToProps(state){
    return{
        name: state.user.name
    }
}

export default connect(mapStateToProps, {}) (UserWelcomeComponentDashboard);